import './index.css';
import './styles/globals.sass';
import { Toaster } from 'sonner';
import MainRouter from 'pages/MainRouter';

function App() {
  return (
    <>
      <MainRouter />
      <Toaster position="top-center" richColors toastOptions={{ style: { width: 'max-content', maxWidth: '480px' } }} />
    </>
  );
}

export default App;
